import { State, Action, StateContext, createPropertySelectors, Selector } from '@ngxs/store';
import { inject, Injectable } from '@angular/core';
import { map } from 'rxjs';

import { IGameStateModel, IVidParam } from './game.models';
import { gameStateDefaults } from './game.utils';
import { FetchGameForId, FetchVidParamsForGame, SetGameId } from './game.actions';
import { GameService } from './game.service';

import { QueryParamsChanged } from 'src/services/query-params/query-params.actions';

@Injectable()
@State<IGameStateModel>({
    name: gameStateDefaults.sliceName,
    defaults: gameStateDefaults.defaults
})
export class GameState {
    public static selectors = createPropertySelectors<IGameStateModel>(GameState);

    private _gameService = inject(GameService);

    @Selector([GameState.selectors.vidParams, GameState.selectors.selectedPeriod])
    public static vidParamForSelectedPeriod(vidParams: IVidParam[] | undefined, selectedPeriod: string | undefined): IVidParam | undefined {
        if (!vidParams || !selectedPeriod) {
            return;
        }

        return vidParams.find(param => param.period === parseInt(selectedPeriod, 10));
    }

    @Action(SetGameId)
    private _setGameId(ctx: StateContext<IGameStateModel>, { gameId }: SetGameId) {
        return ctx.patchState({
            gameId
        });
    }

    @Action(FetchGameForId)
    private _fetchGame(ctx: StateContext<IGameStateModel>, { gameId, params }: FetchGameForId) {
        return this._gameService.getGameWithIdApi(gameId, params).pipe(
            map(response => {
                return ctx.patchState({
                    game: response.game,
                    vidParams: response.vidparams,
                    periods: response.periods,
                    scores: response.scores
                });
            })
        );
    }

    @Action(FetchVidParamsForGame)
    private _fetchVidparamsForGame(ctx: StateContext<IGameStateModel>, { gameId }: FetchVidParamsForGame) {
        return this._gameService.getVidParamsForGameId(gameId).pipe(
            map(response => {
                return ctx.patchState({
                    vidParams: response
                });
            })
        );
    }

    @Action(QueryParamsChanged)
    private _queryParamsChanged(ctx: StateContext<IGameStateModel>, { queryParams }: QueryParamsChanged) {
        return ctx.patchState({
            selectedPeriod: queryParams.period
        });
    }
}
